import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className = '' }: CardProps) {
  return (
    <div className={`bg-[#1a1f2e] rounded-lg p-6 h-full flex flex-col overflow-hidden relative ${className}`}>
      {children}
    </div>
  );
}
